import React, { useState, useEffect, useRef,useCallback } from 'react';
import styles from './Sidebar.module.css';
import Imagenes from '../../../images/logoturismo.png';
import SolicitudLogo from '../../../images/crearsolicitud.png';
import Logossoli from '../../../images/21.png';
import cambiologo from '../../../images/32.png';
import Logofflogo from '../../../images/cierresesion.png';
import { logout } from '../../../redux/actions/auth';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { resetSolicitud } from '../../../redux/actions/solicitud';

const Sidebar = ({ logout }) => {
    const dispatch = useDispatch();
    const [showSidebar, setShowSidebar] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const logoutHandler = () => {
        logout()
        setRedirect(true);
    }
    if (redirect) {
        window.location.reload(false);
        window.location.href = '/';
    }
    const categoryRef = useRef(null);

    const handleClickOutside = (event) => {
        if (categoryRef.current && !categoryRef.current.contains(event.target)) {
            setShowSidebar(true);
        }
    };
    const handleCreateSolicitud = useCallback((e) => {
        dispatch(resetSolicitud());
    }, [dispatch]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSidebarClick = () => {
        setShowSidebar(!showSidebar); // Invierte el valor actual de showSidebar
    };

    return (

        <>
            {showSidebar ? (
                <div className={styles.backdrop} onClick={handleSidebarClick}>
                    <div className={styles.panel} ref={categoryRef}>
                        <img className={styles.logo} src={Imagenes} alt="DUOC ECOTURISMO" />
                        <hr />
                        <div className={styles.columns}>
                            <ul className={styles.list}>
                                <Link className={styles.item} to='/request' onClick={handleCreateSolicitud}>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={SolicitudLogo} alt="" />
                                        <p className={styles.itemText}>Crear Solicitud</p> 
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/landing'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={Logossoli} alt="" />
                                        <p className={styles.itemText}>Solicitudes</p> 
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/CambioContrasena'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={cambiologo} alt="" />
                                        <p className={styles.itemText}>Cambio de contraseña</p>
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/' onClick={logoutHandler}>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={Logofflogo} alt="" />
                                        <p className={styles.itemText}>Cerrar sesión</p>
                                        </div>
                                </Link>
                            </ul>

                        </div>
                    </div>
                </div>
            ):(<button onClick={handleSidebarClick} className={styles.toggle}>
            ❯
        </button>)}
        </>
    );
};

export default connect(null, {
    logout
})(Sidebar);
